/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportCreateFragmentUploadMutationRequest, SocialExportCreateFragmentUploadMutationResponse, SocialExportCreateFragmentUploadPathParams, SocialExportCreateFragmentUpload400, SocialExportCreateFragmentUpload401, SocialExportCreateFragmentUpload403, SocialExportCreateFragmentUpload404 } from "../models/SocialExportCreateFragmentUpload";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportCreateFragmentUpload } from "../axios/socialExportCreateFragmentUpload";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportCreateFragmentUploadMutationKey = () => [{ url: '/social-export/v1/upload/fragments/:fragment' }] as const

export type SocialExportCreateFragmentUploadMutationKey = ReturnType<typeof socialExportCreateFragmentUploadMutationKey>

export function socialExportCreateFragmentUploadMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SocialExportCreateFragmentUploadMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = socialExportCreateFragmentUploadMutationKey()
        return mutationOptions<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, {fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ fragment, data }) => {
            return socialExportCreateFragmentUpload(fragment, data, config)
          },
        })

}

/**
 * @description Creates an upload from a fragment and queues publishing to the selected connection/platform. Deprecated: use POST /upload with a media URL source instead.
 * @summary Start upload of fragment media to a platform
 * {@link /social-export/v1/upload/fragments/:fragment}
 * @deprecated
 */
export function useSocialExportCreateFragmentUpload<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, {fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SocialExportCreateFragmentUploadMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportCreateFragmentUploadMutationKey()

          const baseOptions = socialExportCreateFragmentUploadMutationOptions(config) as UseMutationOptions<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, {fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest}, TContext>
          

          return useMutation<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, {fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportCreateFragmentUploadMutationResponse, ResponseErrorConfig<SocialExportCreateFragmentUpload400 | SocialExportCreateFragmentUpload401 | SocialExportCreateFragmentUpload403 | SocialExportCreateFragmentUpload404>, {fragment: SocialExportCreateFragmentUploadPathParams["fragment"], data: SocialExportCreateFragmentUploadMutationRequest}, TContext>
      
}